import { fetchAuthSession } from 'aws-amplify/auth';
import axios, { AxiosHeaders, AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';

const axiosInstance: AxiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_FACADE_ENDPOINT}`, // Replace with your API base URL
  });

axiosInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString() ?? '';
        if (token.length > 0 && config.headers) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;